import { createContext } from 'react';

export const AudioManagerContext = createContext<any>(null);
